// extracted by mini-css-extract-plugin
module.exports = {"header":"ImageDrawer_header__JRrRg","propertyImage":"ImageDrawer_propertyImage__dMYWG","drawer":"ImageDrawer_drawer__YgUcs","drawerBody":"ImageDrawer_drawerBody__hLD_w"};